<template>
  <div class="villa-info-container mt-2" :class="isPhone ? '' : 'mx-3'">
    <div class="d-flex flex-column">
      <p class="raleway-bold-p15">
        VOUS SOUHAITEZ NOUS EN PARLER ?
      </p>
      <p class="raleway-reg-p15">Notre service de conciergerie est disponible pour vous accompagner dans l'organisation de votre séjour. Nous sommes disponibles du lundi au vendredi de 9h à 18h (heure locale) : <a href="https://wa.me/33626203846" target="_blank" class="raleway-semi-p15 text-underline phone-link">+ 33 6 26 20 38 46</a></p>
      <div v-if="!noVilla" class="d-flex raleway-reg-p15" style="gap: 8px; margin-top: 8px;">
        <!-- <svg
          xmlns="http://www.w3.org/2000/svg"
          width="25"
          height="25"
          fill="currentColor"
          viewBox="0 0 16 16"
          aria-hidden="true"
        >
          <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
          <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
        </svg> -->
      </div>
    </div>
  </div>
</template>

<script>
import { data } from 'jquery';

export default {
  name: "VillaInfoContainer",
  props: {
    noVilla: {
      type: Boolean,
      default: false,
    },
    lodging: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isPhone: window.innerWidth <= 768,
    };
  },
};
</script>

<style scoped lang="scss">
.villa-info-container {
  background: #FFFFFF 0% 0% no-repeat padding-box;
  height: fit-content;
  padding: 5px;
}

.text-underline {
  text-decoration: underline;
}

.phone-link {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    opacity: 0.8;
  }
}
</style>
